// extracted by mini-css-extract-plugin
export default {"invalid":"styles_invalid__uw2UB"};